import React, { useState } from 'react';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import {showToast} from '../../components/toasts/index.jsx'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './styles/tabs.css';
import Weekly from './pages/Weekly';
import Fleet from './pages/Fleet';
import Driver from './pages/Driver';
import Site from './pages/Site';
import Axios from 'axios';
import { selectStyles, multiSelectStyles, midMultiSelectStyles, comparisonOptions } from './components/helpers/selectFormHelper';
import { transformConsolidatedTotals, transformFleetTotals, transformFleetTrips } from './components/helpers/paymentsHelper';
import {
  transformDriverBreakdown,
  transformTripBreakdown,
  transformDriverTripSplit,
  transformRideshareBreakdown,
  transformIncentiveBreakdown,
  transformPaymentBreakdown,
  transformFleetBalance 
} from './components/helpers/driverHelper';

function Payments({ fleets,companies, params, current_user, payment_platform_mvp }) {
  const isAdmin = current_user?.role === 'admin';
  const isLogisticsSpecialist = current_user?.role === 'logistics_specialist';
  // Finance roles see client Billing; logistics specialists see Driver Pay. Only
  // admin and logistics_specialist can reach Payments (see PaymentPolicy),
  // so admin is the only finance role that actually renders here.
  const FINANCE_ROLES = ['admin'];
  const isFinance = FINANCE_ROLES.includes(current_user?.role);
  const [selectedComparison, setSelectedComparison] = useState({ value: '1', label: '1 week' });
  // The date-range picker's selected preset key. It decides which period the
  // Weekly Overview compares against ('this_week' -> previous week, 'this_month'
  // -> previous month, and so on), with 'year_to_date' and 'custom' getting no
  // comparison at all. Only the flag-on request carries it; the flag-off body
  // keeps the release shape.
  const [comparisonPeriod, setComparisonPeriod] = useState('this_week');
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [siteOverview, setSiteOverview] = useState({});
  const [weeklyData, setWeeklyData] = useState([]);
  // Legacy (flag-off) top-of-page aggregator feeds — see paymentsHelper transforms.
  const [consolidatedTotals, setConsolidatedTotals] = useState({});
  const [fleetTrips, setFleetTrips] = useState({});
  const [fleetTotals, setFleetTotals] = useState({});
  // Weekly Overview Executive/Invoicing view. Lifted out of Weekly so react-tabs
  // unmounting the panel on tab switch does not reset the user's choice.
  const [weeklyExecutiveView, setWeeklyExecutiveView] = useState(true);

  // driver states
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    // const [selectedFleets, setSelectedFleets] = useState([]);
    const [isStatementsModalOpen, setStatementsModalOpen] = useState(false);
    const [dropdown, setDropdown] = useState(false);
    const [driverTable, setDriverTable] = useState([]);
    const [fleetData, setFleetData] = useState(null);
    const [paymentBreakdown, setPaymentBreakdown] = useState({});
    const [tripBreakdown, setTripBreakdown] = useState({});
    const [driverTripSplit, setDriverTripSplit] = useState({});
    const [incentiveBreakdown, setIncentiveBreakdown] = useState({});
    const [fleetBalance, setFleetBalance] = useState({});
    const [rideshareBreakdown, setRideshareBreakdown] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    
    const [selectedRows, setSelectedRows] = useState([]);
  
  
    const [itemLoad, setItemLoad] = useState(false);
    const [editMode, setEditMode] = useState({});
    const [editedValues, setEditedValues] = useState({});
  
  const [uploadErrors, setUploadErrors] = useState([]);
  // eof driver states

  // Land on last week: the finance cycle works a completed week, and the current one is
  // always partial. isoWeek matches WeeklyDatePicker's Monday start, DD/MM/YYYY its format.
  const [week, setWeek] = useState(() => {
    const lastWeek = moment().subtract(1, 'week');

    return {
      from: params.start_date_filter || lastWeek.clone().startOf('isoWeek').format('DD/MM/YYYY'),
      to: params.end_date_filter || lastWeek.clone().endOf('isoWeek').format('DD/MM/YYYY'),
    };
  });
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: '',
  });

  const ALL_OPTION = { label: "Select fleet", value: "__ALL__" };
  const [fleetTabFleet, setFleetTabFleet] = useState(ALL_OPTION);
  const [driverTabFleets, setDriverTabFleets] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const fleetOptions = React.useMemo(() => {
    const base = fleets.map(f => ({ label: f.name, value: f.id }));
    return [ALL_OPTION, ...base];
  }, [fleets]);

  const toOptionObjects = React.useCallback((arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return [];

    if (typeof arr[0] === "object" && arr[0] !== null && "value" in arr[0]) {
      const ids = new Set(arr.map(o => o.value));
      return fleetOptions.filter(o => ids.has(o.value));
    }

    const idSet = new Set(arr);
    return fleetOptions.filter(o => idSet.has(o.value));
  }, [fleetOptions]);

  const buildDriverFleetsPayload = () =>
    (driverTabFleets || []).map(o => ({ value: o.value, label: o.label }));

  const [currentPage, setCurrentPage] = useState(1);
  const [siteSearch, setSiteSearch] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchCompanies = async (searchOverride) => {
    setLoading(true);
    // Only a string counts as an explicit search override. Event objects (from a
    // bare onClick={fetchCompanies}) must never reach the request body — their
    // circular React fiber references crash axios's JSON serialization.
    const q = typeof searchOverride === 'string' ? searchOverride : searchQuery;
    try {
      // Flag off restores the release request shape (a single selected_week, no
      // search) so the legacy report runs exactly as it did before the flag; flag
      // on sends the applied date range and search term for the new report.
      const requestBody = payment_platform_mvp
        ? { start_date: week.from, end_date: week.to, comparison_period: comparisonPeriod, q }
        : { selected_week: week.from, comparison_period: selectedComparison.value };
      const { data } = await Axios.post("/weekly_account_snapshots/weekly_summary", requestBody);

      const filteredData = data.company_data.filter(company => company !== null);

      setWeeklyData(filteredData);
      setConsolidatedTotals(transformConsolidatedTotals(data))

    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      showToast("error", 'Error fetching fleet payments')
    }
    setLoading(false);
  };

  const fetchFleetOverview = async () => {
    setLoading(true);
    try {
      const { data } = await Axios.post("/weekly_account_snapshots/fleet_summary", {
        start_date: week.from,
        end_date: week.to,
        user_fleets: fleetTabFleet,
        user_companies: selectedCompanies
      });

      // const filteredData = data.company_data.filter(company => company !== null);

      setWeeklyData(data.fleet_overview);
      setFleetTrips(transformFleetTrips(data))
      setFleetTotals(transformFleetTotals(data))

    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      showToast("error", 'Error fetching fleet payments')
    }
    setLoading(false);
  };

  const fetchSiteOverview = async (page, search = siteSearch) => {
    setLoading(true);
    try {
      const { data } = await Axios.post("/payments/site_overview", {
        start_date: week.from,
        end_date: week.to,
        user_company: selectedCompanies,
        page: page,
        search: search
      });

      if (page === 1) {
        setSiteOverview(data);
      } else {
        setSiteOverview(prev => ({ ...prev, ...data }));
        // setSiteOverview(prev => ({
        //   ...prev,
        //   [page]: response.data, // Store each page's data under its number
        // }));
      }
      // const filteredData = data.company_data.filter(company => company !== null);

      // setSiteOverview(data);

      setCurrentPage(data.current_page);
      setHasMore(!!data.next_page);

    } catch (error) {
      console.error("Error fetching site information:", error);
      showToast("error", 'Error fetching company overview')

    }
    setLoading(false);
  };

  // A new term restarts at page 1: page 3 of the previous search means nothing.
  const handleSiteSearch = (term) => {
    setSiteSearch(term);
    setCurrentPage(1);
    fetchSiteOverview(1, term);
  };

  const handleNext = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    if (!siteOverview[nextPage]) {
      fetchSiteOverview(nextPage);
    }
  };
  
  const handleBack = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);
      if (!siteOverview[prevPage]) {
        fetchSiteOverview(prevPage);
      }
    }
  };

  const fetchApprovalFlag = async (approval_flag) => {
    setLoading(true);
    try {
      await Axios.post("/payments/admin_approval_lock", {
        approval_flag: approval_flag,
        user_company: selectedCompanies,
        selected_week: week.from,
      });
      await fetchSiteOverview(currentPage);
    } catch (error) {
      console.error("Error:", error);
      showToast("error", "Failed to update approval status.");
    } finally {
      setLoading(false);
    }
  };

  const updateSiteOverviewTrips = async (id, formData) => {
    setLoading(true);
    try {
      await Axios.put(`/payments/grouped_trip_updates/${id}`, formData);
    } catch (error) {
      console.error("Error updating driver:", error);
      showToast("error", 'Failed to update driver.')
    }

    fetchSiteOverview(currentPage);
  };

  const downloadSiteCsv = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(
        "/payments/download_site_csv", 
        {
          user_company: selectedCompanies,
          download_week: week.from
        }
      );

      setLoading(false);
      showToast("success", `${response.data.message}`)
    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      setLoading(false)
      showToast("error", 'Download Failed!')
    }
  };

  const downloadDriverCsv = async (selectedWeek) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        "/payments/download_driver_csv",
        {
          user_fleets: buildDriverFleetsPayload(),
          download_week: selectedWeek.from
        }
      );

      setLoading(false);
      showToast("success", `${response.data.message}`)

      const missingBillings = response.data.missing_client_billings || [];
      if (missingBillings.length > 0) {
        const shown = missingBillings.slice(0, 10);
        const extra = missingBillings.length - shown.length;
        showToast(
          "warning",
          "Total Revenue will be understated — missing client billing for:\n" +
            shown.join("\n") +
            (extra > 0 ? `\n+${extra} more` : "")
        );
      }
    } catch {
      setLoading(false);
      showToast("error", 'Download Failed!')
    }
  };

  const downloadXeroCsv = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(
        "/payments/download_xero_csv",
        {
          user_company: selectedCompanies,
          download_week: week.from
        }
      );

      showToast("success", response.data.message);
    } catch (error) {
      showToast("error", error.response?.data?.error ?? "Download Failed!");
    } finally {
      setLoading(false);
    }
  };  
  
  // Weekly Overview server-side search: hold the query so the plain search button
  // and the debounced in-table search both re-fetch with the same `q`.
  const onWeeklySearch = (q) => {
    setSearchQuery(q);
    fetchCompanies(q);
  };

  // Per-company invoicing download: the vehicle/tier table + client-billing
  // payout for the row's company over the applied range. Backed by
  // Payments::WeeklyOverviewReport (ticket 86cad7jru), so the CSV matches the
  // expanded invoicing table; it is gated behind payment_platform_mvp and is
  // distinct from the driver-payout Xero export.
  const downloadInvoicingRow = async (item) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        "/payments/download_invoicing_csv",
        {
          user_company: { value: item.company_id, label: item.company_name },
          start_date: week.from,
          end_date: week.to,
        }
      );

      showToast("success", response.data.message);
    } catch (error) {
      showToast("error", error.response?.data?.error ?? "Download Failed!");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (selectedValue) => {
    setSelectedComparison(selectedValue);
    setSelectedOption(selectedValue);
  };


  // DRIVER OVERVIEW


  
  const fetchFleetPayments = async () => {
    try {
      const { data } = await Axios.post("/weekly_account_snapshots/driver_summary", {
        user_fleets: buildDriverFleetsPayload(),
        start_date: week.from,
        end_date: week.to
      });

      const serverSelected = data?.selected_fleets;
      if (Array.isArray(serverSelected)) {
        setDriverTabFleets(toOptionObjects(serverSelected));
      }

      setFleetData(transformDriverBreakdown(data));
      setTripBreakdown(transformTripBreakdown(data));
      setDriverTripSplit(transformDriverTripSplit(data));
      setPaymentBreakdown(transformPaymentBreakdown(data));
      setFleetBalance(transformFleetBalance(data));
      setIncentiveBreakdown(transformIncentiveBreakdown(data));
      setRideshareBreakdown(transformRideshareBreakdown(data));
      setDriverTable(data.driver_table);

    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      alert("Error fetching fleet payments:", error);
    }
  };

  // EntityMultiSelect adapter for Driver Overview tab. driverTabFleets holds the real
  // selected fleet options (never a synthetic "__ALL__" marker): EntityMultiSelect keeps
  // its own mirrored copy and syncs both ways, so the value it receives back must equal
  // the value it pushed. A lossy all -> [ALL_OPTION] -> [...fleets] round-trip put the
  // two mirror effects permanently one render out of phase and spun an infinite loop.
  const entitySelectedFleets = React.useMemo(() => {
    const selectedIds = new Set(driverTabFleets.map(o => o.value));
    return fleets.filter(f => selectedIds.has(f.id));
  }, [driverTabFleets, fleets]);

  const onEntityFleetChange = React.useCallback((items) => {
    setDriverTabFleets((items || []).map(f => ({ value: f.id, label: f.name })));
  }, []);

  const handleUpdateAll = async () => {
    const editedSnapshotIds = Object.keys(editMode).filter(
      (snapshotId) => editMode[snapshotId]
    );
  
    setItemLoad(true);
    try {
      await Promise.all(
        editedSnapshotIds.map((id) =>
          Axios.put(`/weekly_account_snapshots/manual_update_snapshot/${id}`, editedValues[id])
        )
      );
      setEditMode((prev) => {
        const newEditMode = { ...prev };
        editedSnapshotIds.forEach((id) => {
          newEditMode[id] = false;
        });
        return newEditMode;
      });
    } catch (error) {
      console.error("Error updating snapshots:", error);
      showToast("error", 'Failed to update some snapshots.')
    }
    setItemLoad(false);
    setLoading(true);
  };

  const handleSaveClick = async (accountId) => {
    setItemLoad(true);
    try {
      await Axios.put(`/weekly_account_snapshots/manual_update_snapshot/${accountId}`, editedValues[accountId]);
      setEditMode((prev) => ({ ...prev, [accountId]: false }));
      showToast("success", 'Updated driver');
    } catch (error) {
      console.error("Error updating driver:", error);
      showToast("error", 'Failed to update driver.')
    }
    setItemLoad(false);
    setLoading(true);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('bonuses_file', selectedFile);

    setModalLoading(true);

    try {
      const response = await Axios.post(
        "/weekly_account_snapshots/upload_csv",
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
          }
        }
      );

      setSelectedFile(null);
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';

      const { message, errors, updated_count: updatedCount } = response.data ?? {};
      if (errors?.length) {
        setUploadErrors(errors);
        showToast(errors.length && !updatedCount ? "error" : "warning", message || 'Upload finished with errors.');
      } else {
        setUploadErrors([]);
        showToast("success", message ?? 'Upload Successful!');
      }
      setLoading(true);
    } catch (error) {
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      setSelectedFile(null);
      const data = error.response?.data;
      const msg = typeof data === 'string' ? data : data?.message;
      setUploadErrors(data?.errors || []);
      showToast("error", msg || 'Upload failed.');
    } finally {
      setModalLoading(false);
    }
  };

  const downloadPdf = async () => {
    setModalLoading(true);
    try {
      const response = await Axios.get('/weekly_account_snapshots/print_driver_statement', {
        params: {selected_rows: selectedRows, statement_week: week.from},
        responseType: 'json',
        headers: {
          Accept: 'application/json',
        },
      });
      showToast("success", response.data?.message ?? 'The statement has been sent to your email address.');
    } catch (error) {
      showToast("error", error.response.data?.message ?? 'Error requesting driver statement');
    }
    setModalLoading(false);
  }

  const downloadFleetStatement = async (week_number) => {
    setLoading(true);

    const download_value = (week_number === 1)
      ? week.from
      : weeklyData.download_previous;

    try {
      const response = await Axios.get('/weekly_account_snapshots/print_fleet_pdf', {
        params: {
          selected_fleets: fleetTabFleet,
          statement_week: download_value,
        },
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
        },
      });
      showToast("success", response.data?.message ?? 'The statement has been sent to your email address.');
    } catch (error) {
      showToast("error", error.response.data?.message ?? 'Error requesting fleet statement');
    }
    setLoading(false);
  }

  const downloadTemplate = async () => {
    setModalLoading(true);
    try {
      const response = await Axios.post(
        "/weekly_account_snapshots/download_csv",
        {
          user_fleets: buildDriverFleetsPayload(),
          download_week: week.from
        }, 
        {
          headers: {
            'Accept': 'text/csv',
            'Content-Type': 'application/json'
          },
          responseType: 'json'
        }
      );

      setModalLoading(false);
      showToast("success", `${response.data.message}`)
    } catch (error) {
      console.error("Error fetching fleet payments:", error);
      setModalLoading(false)
      showToast("error", 'Download Failed!')
    }
  };

  const resetDriverState = () => {
    setSelectedWeek(null);
    setDriverTabFleets([]);
    setFleetData(null)
    setDriverTable([]);
    setPaymentBreakdown({});
    setTripBreakdown({});
    setDriverTripSplit({});
    setIncentiveBreakdown({});
  };

  
  // EOF DRIVER OVERVIEW

  // Company Overview reaches both the admin tab set and the logistics_specialist's
  // sole tab with an identical prop list — shared once so the two <Site> render
  // sites can't drift out of sync with each other.
  const siteProps = {
    loading,
    selectStyles,
    multiSelectStyles,
    midMultiSelectStyles,
    handleChange,
    companies,
    params,
    week,
    setWeek,
    selectedCompanies,
    setSelectedCompanies,
    fetchSiteOverview,
    onSiteSearch: handleSiteSearch,
    setSiteSearch,
    siteOverview,
    setSiteOverview,
    updateSiteOverviewTrips,
    downloadSiteCsv,
    downloadXeroCsv,
    toast,
    setToast,
    styles: selectStyles,
    fetchApprovalFlag,
    currentPage,
    hasMore,
    handleNext,
    handleBack,
    isAdmin,
    isFinance,
    isLogisticsSpecialist,
    paymentPlatformMvp: payment_platform_mvp,
  };

  return (
    <>
      <div className="flex w-full mb-2 justify-between">
        <div className="text-xl font-medium text-gray-700">
          <div className="flex flex-row">
            <h3 className="">Payments</h3>
          </div>
          <p className="text-sm text-gray-500">
            Logged in as {current_user.name} {current_user.surname}
          </p>
        </div>
      </div>
      <Tabs
        // react-tabs unmounts the Weekly panel on a tab switch, so its search box
        // clears itself while the query lives here and did not. Returning to the tab
        // re-fetched with the stale q: rows filtered to a company the user could no
        // longer see named anywhere, and no way to clear it but typing and deleting.
        onSelect={() => setSearchQuery('')}
        style={{
          boxShadow:
            '-4px 4px 6px rgba(0, 0, 0, 0.05), 4px 4px 6px rgba(0, 0, 0, 0.05),0 4px 6px rgba(0, 0, 0, 0.05)',
          paddingleft: '10px',
          paddingRight: '0px',
          borderRadius: '15px 15px 0 0',
          backgroundColor: 'white',
        }}>
        {/* Tab headings */}
        <TabList
          style={{ display: 'flex', width: '100%', borderBottom: 'none' }}
        >
          {isAdmin && (
            <>
              <Tab className="tab" selectedClassName="tab--selected">
                Weekly Overview
              </Tab>
              <Tab className="tab" selectedClassName="tab--selected">
                Company Overview
              </Tab>
              <Tab className="tab" selectedClassName="tab--selected">
                Fleet Overview
              </Tab>
              <Tab className="tab" selectedClassName="tab--selected">
                Driver Overview
              </Tab>
            </>
          )}

          {isLogisticsSpecialist && (
            <Tab className="tab" selectedClassName="tab--selected">
              Company Overview
            </Tab>
          )}
        </TabList>

        {isAdmin && (
          <>
            {/* Tab 1: Weekly Overview */}
            <TabPanel style={{ background: 'white' }}>
              <div className="tabs-tab-panel">
                <Weekly
                  loading={loading}
                  selectStyles={selectStyles}
                  data={weeklyData}
                  setData={setWeeklyData}
                  handleChange={handleChange}
                  comparisonOptions={comparisonOptions}
                  week={week}
                  setWeek={setWeek}
                  fetchCompanies={fetchCompanies}
                  selectedOption={selectedOption}
                  consolidatedTotals={consolidatedTotals}
                  selectedComparison={selectedComparison}
                  setComparisonPeriod={setComparisonPeriod}
                  paymentPlatformMvp={payment_platform_mvp}
                  tabView={weeklyExecutiveView}
                  setTabView={setWeeklyExecutiveView}
                  onSearch={onWeeklySearch}
                  onDownloadRow={downloadInvoicingRow}
                />
              </div>
            </TabPanel>

            {/* Tab 2: Company Overview */}
            <TabPanel>
              <div className="tabs-tab-panel">
                <Site {...siteProps} />
              </div>
            </TabPanel>

            {/* Tab 3: Fleet Overview */}
            <TabPanel>
              <div className="tabs-tab-panel">
                <Fleet
                  fleets={fleets}
                  comparisonOptions={comparisonOptions}
                  loading={loading}
                  companies={companies}
                  params={params}
                  handleChange={handleChange}
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                  selectStyles={selectStyles}
                  selectedFleet={fleetTabFleet}
                  setSelectedFleet={setFleetTabFleet}
                  defaultSelectedFleet={ALL_OPTION}
                  selectedCompanies={selectedCompanies}
                  setSelectedCompanies={setSelectedCompanies}
                  fetchFleetOverview={fetchFleetOverview}
                  data={weeklyData}
                  setData={setWeeklyData}
                  fleetTrips={fleetTrips}
                  fleetTotals={fleetTotals}
                  week={week}
                  setWeek={setWeek}
                  multiSelectStyles={multiSelectStyles}
                  downloadFleetStatement={downloadFleetStatement}
                  paymentPlatformMvp={payment_platform_mvp}
                />
              </div>
            </TabPanel>

            {/* Tab 4: Driver Overview */}
            <TabPanel>
              <div className="tabs-tab-panel">
                <Driver
                  fleets={fleets}
                  week={week}
                  setWeek={setWeek}
                  selectStyles={selectStyles}
                  midMultiSelectStyles={midMultiSelectStyles}
                  fetchFleetPayments={fetchFleetPayments}
                  loading={loading}
                  setLoading={setLoading}
                  entitySelectedFleets={entitySelectedFleets}
                  onEntityFleetChange={onEntityFleetChange}
                  handleSaveClick={handleSaveClick}
                  handleUpdateAll={handleUpdateAll}
                  downloadPdf={downloadPdf}
                  handleUpload={handleUpload}
                  downloadTemplate={downloadTemplate}
                  selectedWeek={selectedWeek}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  modalLoading={modalLoading}
                  isStatementsModalOpen={isStatementsModalOpen}
                  setStatementsModalOpen={setStatementsModalOpen}
                  dropdown={dropdown}
                  setDropdown={setDropdown}
                  driverTable={driverTable}
                  fleetData={fleetData}
                  setToast={setToast}
                  paymentBreakdown={paymentBreakdown}
                  tripBreakdown={tripBreakdown}
                  driverTripSplit={driverTripSplit}
                  incentiveBreakdown={incentiveBreakdown}
                  fleetBalance={fleetBalance}
                  rideshareBreakdown={rideshareBreakdown}
                  setSelectedFile={setSelectedFile}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  itemLoad={itemLoad}
                  editMode={editMode}
                  setEditMode={setEditMode}
                  editedValues={editedValues}
                  setEditedValues={setEditedValues}
                  toast={toast}
                  resetDriverState={resetDriverState}
                  downloadDriverCsv={downloadDriverCsv}
                  uploadErrors={uploadErrors}
                  clearUploadErrors={() => setUploadErrors([])}
                  paymentPlatformMvp={payment_platform_mvp}
                />
              </div>
            </TabPanel>
          </>
        )}

        {isLogisticsSpecialist && (
          <TabPanel>
            <div className="tabs-tab-panel">
              <Site {...siteProps} />
            </div>
          </TabPanel>
        )}
      </Tabs>
      <ToastContainer position="bottom-right" />
    </>
  );
}

export default Payments;
